<script lang="ts">
  import cn from 'classnames'

  import Line from './Line.svelte'

  import css from '#css/comments.pcss.json'

  export let levels: Array<{
    id: number | string,
    parentId: number | string,
    hasLaterSiblings: boolean,
    hasChildren: boolean,
    hideCurrent?: boolean,
    shortHeight?: boolean
  }>
</script>

<div class={cn(css['comment__lines'], {
    [`${css['comment__lines--short']}`]: levels[levels.length - 1].shortHeight
})}>
    {#each levels as level, i}
        <Line level={level} isCurrentLevel={i === levels.length - 1} i={i}/>
    {/each}
</div>
